const severityToColor = severity => {
  const s = severity?.toLowerCase();
  if (s === "high") return "red";
  if (s === "medium") return "amber";
  return "green";
};

const priorityToColor = priority => {
  const p = priority?.toLowerCase();
  if (p === "high") return "amber";
  if (p === "medium") return "green";
  return "gray";
};

export const mapAiNotes = (raw = {}) => {
  const painPointItems = (raw.painPoints || []).map(p => ({
    cat: "Pain point",
    color: severityToColor(p.severity),
    text: p.painPoint
  }));
  const requirementItems = (raw.requirements || []).map(r => ({
    cat: "Requirement",
    color: priorityToColor(r.priority),
    text: r.requirement
  }));
  const buyingSignalItems = (raw.buyingSignals || []).map(b => ({
    cat: "Buying signal",
    color: "green",
    text: b.signal
  }));

  return {
    summary: raw.conversationSummary?.shortSummary || "",
    sentiment: raw.conversationSummary?.overallSentiment || "",
    keyPoints: [...painPointItems, ...requirementItems, ...buyingSignalItems],
    objections: (raw.objections || []).map(o => ({
      label: o.objection,
      desc: o.suggestedHandling
    })),
    nextSteps: (raw.nextBestSteps || []).map(n => n.step),
    actionItems: raw.actionItems || [],
    topics: raw.topicsDiscussed || []
  };
};

const formatTime = seconds => {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const mapTranscriptLines = (transcripts = []) => {
  if (!transcripts.length) return [];
  return transcripts.map(t => {
    const time = t.startTime != null ? formatTime(t.startTime) : "--:--";
    const isCaller = t.speaker.toLowerCase() === "caller";
    return {
      s: isCaller ? "rep" : "prospect",
      name: isCaller ? "Caller" : "Prospect",
      time,
      text: t.transcript
    };
  });
};
